module.exports = __webpack_public_path__ + "media/images/enticom_logo-2aed43a08fecbe7d3cfa30acf0c5cdcd.png";